import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as n, normalizeClass as d, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCoachingHub",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, h = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, u, _, a) {
  return l(), n("svg", {
    "aria-label": r.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--coaching-hub"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Coaching Hub",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      d: "M8.996 11v-.5h-.5a.5.5 0 0 1 0-1h.5V9a.5.5 0 0 1 1 0v.5h.504l.1.01a.5.5 0 0 1 0 .98l-.1.01h-.504v.5a.5.5 0 0 1-1 0ZM6.031 4.668a.5.5 0 0 1 .455.293l.546 1.203 1.206.548a.501.501 0 0 1 0 .911l-1.206.547-.546 1.204a.5.5 0 0 1-.91 0L5.027 8.17l-1.205-.547a.5.5 0 0 1 0-.911l1.205-.548.547-1.203.036-.065a.5.5 0 0 1 .42-.228Zm-.17 2.081a.501.501 0 0 1-.248.25l-.374.168.374.17.078.045a.5.5 0 0 1 .17.204l.17.373.17-.373.043-.078a.5.5 0 0 1 .204-.171l.373-.17-.373-.169A.501.501 0 0 1 6.2 6.75l-.17-.374-.17.374ZM4 1.5v1h3v-1H4Zm4.5 0 .148.008A1.5 1.5 0 0 1 10 3v1a.5.5 0 1 1-1 0V3a.5.5 0 0 0-.402-.49L8.5 2.5H8a1 1 0 0 1-1 1H4a1 1 0 0 1-.995-.897L3 2.5h-.5A.5.5 0 0 0 2 3v7a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 1 10V3a1.5 1.5 0 0 1 1.5-1.5H3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, h);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=coaching-hub.js.map
